import { inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, from, map, of, Subject, switchMap, tap } from 'rxjs';
import { AgentSuggestedPromptsService } from 'AgentApp/ts/services/agent-suggested-prompts.service';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { PageContextClientTool } from 'AgentApp/ts/client-tools/page-context.client-tool';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
function AgentSuggestedPromptsComponent_Conditional_0_Conditional_7_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "div", 6);
    i0.ɵɵelementEnd();
} }
function AgentSuggestedPromptsComponent_Conditional_0_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, AgentSuggestedPromptsComponent_Conditional_0_Conditional_7_For_1_Template, 2, 0, "div", 5, i0.ɵɵrepeaterTrackByIdentity);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.skeletonRows);
} }
function AgentSuggestedPromptsComponent_Conditional_0_Conditional_8_For_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function AgentSuggestedPromptsComponent_Conditional_0_Conditional_8_For_1_Template_div_click_0_listener() { const prompt_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.selectPrompt(prompt_r4)); })("keydown.enter", function AgentSuggestedPromptsComponent_Conditional_0_Conditional_8_For_1_Template_div_keydown_enter_0_listener() { const prompt_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.selectPrompt(prompt_r4)); })("keydown.space", function AgentSuggestedPromptsComponent_Conditional_0_Conditional_8_For_1_Template_div_keydown_space_0_listener($event) { const prompt_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); $event.preventDefault(); return i0.ɵɵresetView(ctx_r1.selectPrompt(prompt_r4)); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const prompt_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(prompt_r4);
} }
function AgentSuggestedPromptsComponent_Conditional_0_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, AgentSuggestedPromptsComponent_Conditional_0_Conditional_8_For_1_Template, 3, 1, "div", 7, i0.ɵɵrepeaterTrackByIdentity);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.prompts());
} }
function AgentSuggestedPromptsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span");
    i0.ɵɵtext(3, "Suggested prompts");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 2);
    i0.ɵɵlistener("click", function AgentSuggestedPromptsComponent_Conditional_0_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.refresh()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 4);
    i0.ɵɵconditionalCreate(7, AgentSuggestedPromptsComponent_Conditional_0_Conditional_7_Template, 2, 0)(8, AgentSuggestedPromptsComponent_Conditional_0_Conditional_8_Template, 2, 0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r1.isLoading());
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.isLoading() ? 7 : 8);
} }
const SKELETON_ROWS = [0, 1, 2];
export class AgentSuggestedPromptsComponent {
    constructor() {
        this._suggestedPromptsService = inject(AgentSuggestedPromptsService);
        this._pageContextClientTool = inject(PageContextClientTool);
        this.source = input.required(...(ngDevMode ? [{ debugName: "source" }] : []));
        this.promptSelected = output();
        this.prompts = signal([], ...(ngDevMode ? [{ debugName: "prompts" }] : []));
        this.isLoading = signal(false, ...(ngDevMode ? [{ debugName: "isLoading" }] : []));
        this.skeletonRows = SKELETON_ROWS;
        this._loadRequests = new Subject();
        this._loadRequests
            .pipe(tap(() => this.isLoading.set(true)), switchMap((regenerate) => {
            const currentPrompts = this.prompts();
            return this._pageContext().pipe(switchMap((pageContext) => this._suggestedPromptsService.getSuggestedPrompts(this._pageUrl(), this._pageTitle(), this.source(), regenerate, currentPrompts, pageContext)), map((result) => result.prompts ?? []), catchError(() => of(null)));
        }), takeUntilDestroyed())
            .subscribe((prompts) => {
            if (prompts) {
                this.prompts.set(prompts);
            }
            this.isLoading.set(false);
        });
    }
    ngOnInit() {
        this._loadRequests.next(false);
    }
    refresh() {
        window.pendoTrack('Refresh Suggested Prompts', { source: this.source() });
        this._loadRequests.next(true);
    }
    selectPrompt(prompt) {
        window.pendoTrack('Clicked Suggested Prompt', { prompt, source: this.source() });
        this.promptSelected.emit(prompt);
    }
    _pageContext() {
        if (this.source() !== 'side_panel') {
            return of(null);
        }
        return from(this._pageContextClientTool.execute(null)).pipe(catchError(() => of(null)));
    }
    _pageUrl() {
        return this.source() === 'side_panel' ? window.location.href : '';
    }
    _pageTitle() {
        return this.source() === 'side_panel' ? document.title : '';
    }
}
AgentSuggestedPromptsComponent.ɵfac = function AgentSuggestedPromptsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSuggestedPromptsComponent)(); };
AgentSuggestedPromptsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentSuggestedPromptsComponent, selectors: [["ycn-agent-suggested-prompts"]], inputs: { source: [1, "source"] }, outputs: { promptSelected: "promptSelected" }, decls: 1, vars: 1, consts: [["data-testid", "agent-suggested-prompts", 1, "section-ai-prompts"], [1, "section-ai-prompts-title", "d-flex", "align-items-center"], ["type", "button", "title", "Suggest new prompts", "aria-label", "Suggest new prompts", "data-testid", "agent-suggested-prompts-refresh", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "ml-1", 3, "click", "disabled"], ["ycnIcon", "", "name", "icon-reset", "role", "img"], [1, "section-ai-prompts-list"], ["aria-hidden", "true", 1, "section-ai-prompts-item"], [1, "skeleton", "skeleton-blue", "skeleton-rounded", "width-full"], ["role", "button", "tabindex", "0", "data-testid", "agent-suggested-prompt", 1, "section-ai-prompts-item"], ["role", "button", "tabindex", "0", "data-testid", "agent-suggested-prompt", 1, "section-ai-prompts-item", 3, "click", "keydown.enter", "keydown.space"]], template: function AgentSuggestedPromptsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, AgentSuggestedPromptsComponent_Conditional_0_Template, 9, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.isLoading() || ctx.prompts().length ? 0 : -1);
    } }, dependencies: [IconModule, i1.IconDirective], encapsulation: 2, changeDetection: 0 });
